import React, {useState} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import Button from "../../components/common/button/Button";
import styles from "./Welcome.module.scss";
import DefaultLayout from "../../layouts/DefaultLayout";
import Warning from "../../components/common/warning/Warning";
import ReCAPTCHA from "react-google-recaptcha";
import {setNotARobot} from "../../redux/actions";

const Welcome = props => {
  const dispatch = useDispatch();
  const robotData = useSelector(state => state.robot);
  return <DefaultLayout>
    <div className={styles.mainCont}>
      <h2>Notify us online</h2>
      <p>This service has been set up by the NSW Government to let people notify ANZ Bank directly about a person that
        has died, without needing to visit a bank branch with their death certificate.</p>
      <Warning type={'warning'} title={'This service is in BETA for NSW, QLD, VIC and SA only.'}
               description={`To be eligible to notify ANZ using this service, 
a NSW, QLD, VIC or SA Death Certificate needs to have been issued for the person who has died.`}/>
      <p>
        The service matches details about the person who has died against the Australian Death Check, a system that
        holds all the death registration data recorded by each Birth, Deaths and Marriage Registry across Australia.
      </p>
      <p>
        Over the next few pages, this service will ask for the details of;
      </p>
      <ul>
        <li>the person who has died</li>
        <li>your details, as the notifier</li>
      </ul>
      <p>This information will be passed on to ANZ and they’ll be in touch with you within 10 working days to guide you
        through the next steps.
      </p>
      <div>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
          onChange={(value) => {
            dispatch(setNotARobot(value !== null));
          }}
        />
      </div>
      {robotData.notARobot ?
        <div className={`row ${styles.buttonCont}`}>
          <div className={`col-6 ${styles.leftCont}`}>
            <Button onClick={() => {
              window.scrollTo(0, 0);
              props.history.push('/deceased-details')
            }}>Get started</Button>
          </div>
        </div> : null}
    </div>
  </DefaultLayout>
};

export default connect(state => ({
  licenses: state.licenses,
}), {})(Welcome)
